var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.61,
    height: 162.323,
    viewBox: "0 0 164.61 162.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11230 16789.375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11230 -16788.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.792,153.955A74.806,74.806,0,1,0,0,79.149,74.8,74.8,0,0,0,74.792,153.955Z",
    transform: "translate(0 0.097)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.983,55.261v71.947a13.913,13.913,0,0,1-4.967,10.084,14.27,14.27,0,0,1-9.48,3.612H17.015a13.571,13.571,0,0,1-6.922-1.806,9.876,9.876,0,0,1-2.558-1.806,12.136,12.136,0,0,1-3.762-5.268,12.411,12.411,0,0,1-1.053-4.666v-72.1s6.019-5.118,14.6-12.192C26.2,35.544,37.933,25.91,48.166,17.331c5.869-4.967,5.267-4.365,14.3-12.041a18.828,18.828,0,0,1,23.927,0C88.2,6.795,90,8.451,91.807,9.956c3.762,3.01,7.825,6.623,12.34,10.235,9.18,7.676,19.262,16.105,27.238,22.728C139.512,49.692,145.381,54.659,145.983,55.261Z",
    transform: "translate(0.892 -1)",
    fill: "#c0d6fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.474,19.383V64.237L98.6,77.934,91.828,82,77.381,90.577l-6.772,4.214L67.75,96.447l-2.709-1.656L58.57,90.728,44.876,82.148l-6.471-4.064L17.337,64.839V19.383A8.575,8.575,0,0,1,25.915,10.8H112.9A8.575,8.575,0,0,1,121.474,19.383Z",
    transform: "translate(5.687 2.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45,53.7V19.383A8.575,8.575,0,0,1,26.028,10.8h86.981a8.575,8.575,0,0,1,8.578,8.579V54.6",
    transform: "translate(5.724 2.216)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.169,36.891H33.911a2.113,2.113,0,0,1,0-4.214H98.169a2.113,2.113,0,0,1,0,4.214Z",
    transform: "translate(10.483 9.392)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.169,46.412H33.911a2.113,2.113,0,0,1,0-4.214H98.169a2.113,2.113,0,0,1,0,4.214Z",
    transform: "translate(10.483 12.515)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.169,55.932H33.911a2.113,2.113,0,0,1,0-4.214H98.169a2.113,2.113,0,0,1,0,4.214Z",
    transform: "translate(10.483 15.638)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.509,61.352l-6.772,4.063H39.785l-6.471-4.063H93.509Z",
    transform: "translate(10.929 18.798)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.347,70.872l-6.922,4.214H54.856l-6.471-4.214Z",
    transform: "translate(15.873 21.921)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.754,25.974H44.336a2.028,2.028,0,0,1-1.956-2.107,1.9,1.9,0,0,1,1.956-1.956H80.754a2.028,2.028,0,0,1,1.956,2.107A1.9,1.9,0,0,1,80.754,25.974Z",
    transform: "translate(13.902 5.86)",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.983,41.858V113.8a13.913,13.913,0,0,1-4.967,10.084,14.27,14.27,0,0,1-9.48,3.612H17.015a13.571,13.571,0,0,1-6.922-1.806,9.876,9.876,0,0,1-2.558-1.806,12.136,12.136,0,0,1-3.762-5.268,12.411,12.411,0,0,1-1.053-4.666v-72.1L66.827,82.046l5.568,3.462,1.956-1.2,1.806-1.054Z",
    transform: "translate(0.892 12.403)",
    fill: "#738dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.016,123.889a14.27,14.27,0,0,1-9.48,3.612H17.015a13.571,13.571,0,0,1-6.922-1.806,9.876,9.876,0,0,1-2.558-1.806,12.136,12.136,0,0,1-3.762-5.268,12.411,12.411,0,0,1-1.053-4.666v-72.1l7.524,4.515L74.351,84.454l1.806,1.054.15.15,57.486,34.017Z",
    transform: "translate(0.892 12.403)",
    fill: "#dfe9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.745,46.051,61.964,77.058",
    transform: "translate(3.197 13.779)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.794,41.858V113.8a13.913,13.913,0,0,1-4.967,10.084,14.27,14.27,0,0,1-9.48,3.612H15.826A13.571,13.571,0,0,1,8.9,125.695a9.876,9.876,0,0,1-2.558-1.806l7.374-4.364L71.205,85.508l1.956-1.2,1.806-1.054,62.452-37.027Z",
    transform: "translate(2.082 12.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.518,45.258,72.066,82.134l-1.806,1.054-1.956,1.2L14.731,116.151",
    transform: "translate(4.832 13.519)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.377,80.53H69.3a1.655,1.655,0,1,1,0-3.311h38.073a1.655,1.655,0,1,1,0,3.311Z",
    transform: "translate(22.192 24.003)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.377,88.8H69.3a1.655,1.655,0,1,1,0-3.311h38.073a1.655,1.655,0,1,1,0,3.311Z",
    transform: "translate(22.192 26.717)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.606,62.179V44.869c5.718-4.817,10.534-8.88,14.6-12.192",
    transform: "translate(0.855 9.392)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.466,31.431c9.179,7.676,16.252,13.546,16.554,13.848v71.947a14.509,14.509,0,0,1-14.447,13.7c-123.4,0-118.433,1.355-124-3.612a14.747,14.747,0,0,1-4.966-9.934V77.188",
    transform: "translate(0.855 8.983)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.493,11.009C44.45,9.354,46.707,7.4,49.416,5.29a18.828,18.828,0,0,1,23.928,0c.6.6,4.665,3.913,10.384,8.73",
    transform: "translate(13.94 -1)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.107,39.583a5.72,5.72,0,1,0-5.719-5.72A5.719,5.719,0,0,0,117.107,39.583Z",
    transform: "translate(36.54 7.904)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,19.7a2.408,2.408,0,1,0-2.408-2.408A2.408,2.408,0,0,0,111.3,19.7Z",
    transform: "translate(35.723 3.554)",
    fill: "#e2ebff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11110.849 -16673.338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.912,84.135a24.837,24.837,0,0,1-.585,5.156,21.478,21.478,0,0,1-.937,2.929,22.122,22.122,0,0,1-12.761,12.772c-.469.118-.82.351-1.288.469A22.509,22.509,0,1,1,97.433,61.52,22.747,22.747,0,0,1,119.912,84.135Z",
    transform: "translate(-74.72 -61.403)",
    fill: "#eaedf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.912,85.309a24.839,24.839,0,0,1-.585,5.156,21.483,21.483,0,0,1-.937,2.929,22.12,22.12,0,0,1-12.761,12.772c-.469.118-.82.352-1.288.469a22.509,22.509,0,1,1-6.908-43.941A22.747,22.747,0,0,1,119.912,85.309Z",
    transform: "translate(-74.72 -61.404)",
    fill: "#cfae26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.97,103.591a25.014,25.014,0,0,1-2.576,1.172c-.468.118-.819.352-1.288.469A22.567,22.567,0,0,1,74.719,83.788,22.175,22.175,0,0,1,86.427,64.1",
    transform: "translate(-74.719 -61.409)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.31,61.637a24.626,24.626,0,0,1,2.927-.234,22.5,22.5,0,0,1,22.48,22.5,24.837,24.837,0,0,1-.586,5.156,21.34,21.34,0,0,1-.936,2.929,24.81,24.81,0,0,1-3.864,6.562",
    transform: "translate(-74.757 -61.403)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.852,62.693c.117,0,.351-.117.468-.117",
    transform: "translate(-74.749 -61.404)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.115,94.243a2.329,2.329,0,0,1-1.873-.82l-5.152-5.156a2.65,2.65,0,0,1,3.747-3.75L95.115,87.8l9.366-9.374a2.65,2.65,0,0,1,3.747,3.75L96.989,93.423A2.762,2.762,0,0,1,95.115,94.243Z",
    transform: "translate(-74.743 -61.434)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.1d85033e5a5a40c25e65cc53c6a5f1a0.svg";
export { ForwardRef as ReactComponent };